import { Icon, LucideIcon } from "@ews-admin/global-design-system";
import React from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon,
  actions,
  className = "",
}) => {
  return (
    <div className={`mb-8 ${className}`} data-testid="page-header">
      {/* MED-1653: stacks on phones (the actions overflowed to the right at 390 px). */}
      <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center">
        <div className="flex items-center space-x-4 min-w-0">
          {icon && (
            <div className="flex flex-shrink-0 justify-center items-center w-12 h-12 rounded-xl bg-ews-primary">
              <Icon icon={icon} size={"lg"} color="white" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="mb-2 text-2xl font-bold sm:text-3xl text-neutral-900">
              {title}
            </h1>
            {description && <p className="text-neutral-600">{description}</p>}
          </div>
        </div>

        {actions && (
          <div className="flex flex-wrap gap-3 items-center">{actions}</div>
        )}
      </div>
    </div>
  );
};
